class Parsing {
  constructor() {}

  static expression(code) {
    return new Function("const $data = this; return " + code);
  }

  static attr(key: string): string[] | null {
    const reg = /\$data\.(\w+)/g;
    const attr = key.match(reg);
    let attr2 = [];
    if (attr) {
      attr2 = attr.map((d) => {
        d = d.replace("$data.", "");
        return d;
      });
    }
    return attr2 || [];
  }
}

export { Parsing };
